export const selectQuotasData = (state) => state?.admin?.adminQuotasSettings?.quotasData;

export const selectQuotasIsDataLoading = (state) =>
    state?.admin?.adminQuotasSettings?.isDataLoading;

export const selectQuotasQueryParams = (state) => state?.admin?.adminQuotasSettings?.queryParams;

export const selectQuotasTotalPages = (state) => state?.admin?.adminQuotasSettings?.totalPages;
